import {COLORS, tabletAndUp} from '@aboutyou/ui-components';
import styled, {css} from 'styled-components';

export const BackgroundImageOverlay = styled.div<{backgroundImage: string}>`
  background-image: url(${({backgroundImage}) => backgroundImage});
  background-color: ${COLORS.Black};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center left;
  min-height: calc(100vh - 80px);
  max-width: 100%;
  position: relative;
  display: block;
  color: ${COLORS.White};
  padding: 40px 30px;
  ${tabletAndUp(
    css`
      padding: 85px 60px;
      min-height: 100vh;
      background-size: contain;
    `,
  )}
`;
